import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { ComponentType, FC, forwardRef, ReactElement } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { PermissionRuleName } from 'constant';
import { usePermissionForRule } from 'hooks/permissions/use-permission';

export const withHideIfNotAllowed = <T extends any>(
  Component: ComponentType<T>,
): FC<T & { ruleName?: PermissionRuleName }> => {
  const Next = forwardRef<any, T & { ruleName?: PermissionRuleName }>(
    ({ ruleName, ...props }, ref) => {
      const { isAllowedForCurrentUser } = usePermissionForRule();

      return ruleName == null || isAllowedForCurrentUser(ruleName) ? (
        <Component {...(props as any)} ref={ref} />
      ) : (
        <></>
      );
    },
  );

  return setDisplayName(wrapDisplayName(Component, 'withHideIfNotAllowed'))(
    hoistNonReactStatics(Next, Component),
  ) as any;
};

export const HideIfNotAllowed: FC<{ ruleName: PermissionRuleName }> = ({
  ruleName,
  children,
}) => {
  const { isAllowedForCurrentUser } = usePermissionForRule();

  return isAllowedForCurrentUser(ruleName) ? <>{children}</> : <></>;
};

export const SwitchContentBasedOnAccess: FC<{
  ruleName: PermissionRuleName;
  hasAccess: ReactElement;
  doesNotHaveAccess: ReactElement;
}> = ({ ruleName, hasAccess, doesNotHaveAccess }) => {
  const { isAllowedForCurrentUser } = usePermissionForRule();

  return isAllowedForCurrentUser(ruleName) ? hasAccess : doesNotHaveAccess;
};
